var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"btn btn-outline-info",attrs:{"to":_vm.getBackUrl()},nativeOn:{"click":function($event){return _vm.cancel.apply(null, arguments)}}},[_c('span',{staticClass:"fa fa-arrow-left"})])
}
var staticRenderFns = []

export { render, staticRenderFns }